import { Page } from '../views/Page';
import { WidgetProps } from '../../widgets';
import { Col, Row } from 'taltech-styleguide';
import { RootieComponent } from './BasicPage';

export const DashboardPage: React.FC<any> = (props: { widgets:WidgetProps[],title: string}) => {
  const {
    widgets,
    title,
  } = props;
  const widgetComponents = () => {
    return (
      <Row>
        {widgets!
        //  .filter((x: any) => x.type === "widget")
          .map((x: any) => <Col><RootieComponent component={x}/></Col>)}

      </Row>
    );
  };
  return <Page title={title}>
    {widgetComponents()}
  </Page>;
};
